import { FileUpload } from './components/FileUpload'
import { ModelSelector } from './components/ModelSelector'
import { PromptInput } from './components/PromptInput'
import { ResultDisplay } from './components/ResultDisplay'
import { useProcessorStore } from './stores/processorStore'
import { RotateCcw } from 'lucide-react'

function App() {
  const { reset, uploadedFile, messages } = useProcessorStore()

  const showReset = uploadedFile || messages.length > 0

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-800 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-black rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">G</span>
            </div>
            <div>
              <h1 className="font-semibold">Document Analyzer v3</h1>
              <p className="text-xs text-gray-500">
                AI-powered document analysis
              </p>
            </div>
          </div>

          {showReset && (
            <button
              onClick={reset}
              className="flex items-center gap-2 px-3 py-2 text-sm text-gray-400 hover:text-white
                       hover:bg-gray-800 rounded-lg transition-colors"
            >
              <RotateCcw className="w-4 h-4" />
              New Session
            </button>
          )}
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex flex-col max-w-4xl w-full mx-auto">
        {/* Upload and Model selection */}
        <div className="p-4 border-b border-gray-800 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FileUpload />
            <ModelSelector />
          </div>
        </div>

        {/* Chat/Results section */}
        <ResultDisplay />

        {/* Input section */}
        <div className="p-4 border-t border-gray-800">
          <PromptInput />
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-800 px-4 py-3 text-center text-xs text-gray-600">
        Powered by Returned.com
      </footer>
    </div>
  )
}

export default App
